import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { setToken } from '@/lib/auth';

const API = '/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (sessionId) {
      axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
        .then(response => {
          if (response.data.session_token) {
            setToken(response.data.session_token);
          }
          navigate('/dashboard', { state: { user: response.data }, replace: true });
        })
        .catch(error => {
          console.error('Auth error:', error);
          navigate('/login', { replace: true });
        });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-emerald-950">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-amber-600 border-t-transparent mx-auto mb-4"></div>
        <p className="text-white font-bebas text-xl tracking-wider">Authenticating...</p>
      </div>
    </div>
  );
}